import i18n from '@/utils/i18n';

const filters =
  [
    {
      name: "name",
      placeholder: i18n.t('form.name_placeholder'),
      type: "text",
      label: i18n.t('form.name'),
    },
    {
      name: "subject",
      placeholder: i18n.t('form.subject_placeholder'),
      type: "text",
      label: i18n.t('form.subject'),
    }
  ];

export default filters